import React from "react";
import {f_101_formatDateExactly} from "../DevServices/service_functions"

const EventList = (props) => {
  const {rx_event_list} = props
  if (!rx_event_list || rx_event_list.length === 0) return null;

  //console.log(rx_event_list)
  return (
    <>
    {/* <p>Hello from EventList</p> */}
    <DataTable data = {rx_event_list} />
    </>
  )
}

export default EventList;

const DataTable = ({ data }) => {
  if (!data || data.length === 0) {
      return <p>No data available</p>;
  }

  return (
    <div className="container mt-5">
          <h2>Event Records</h2>
          <table className="table table-striped">
              <thead>
                  <tr>
                      <th>ID</th>
                      {/* <th>Dev ID</th> */}
                      <th>Code</th>
                      <th>description</th>
                      <th>Data Created</th>
                  </tr>
              </thead>
              <tbody>
                  {data.map((item) => (
                      <tr key={item.id}>
                          <td>{item.id}</td>
                          {/* <td>{item.dev_id}</td> */}
                          <td>{item.code}</td>
                          <td>{item.description}</td>
                          <td>{f_101_formatDateExactly(item.date_created)}</td>
                          {/* <td>{new Date(item.date_created).toLocaleString()}</td> */}
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
  );
};